module.exports = __webpack_public_path__ + "7b5ae009c93a251f853f166980ffc4fe.pdf";